export class AssociationUI {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get association() {
        return this.parent;
    }
    get shouldShowTemporaryFalseFeedback_1500ms() {
        if (!this.association.dateOfLatestFailedAttempt)
            return false;
        return (this.association.context.app.appClock.clock_250.tickingTime <=
            this.association.dateOfLatestFailedAttempt.getTime() + 1500);
    }
}
